import React, { useEffect, useState } from 'react';
import './Admin.css';
import AdminBlog from '../../components/admin/adminBlog';
import AdminLookbook from '../../components/admin/adminLookbook';
import AdminUsers from '../../components/admin/AdminUsers';
import AdminArticles from '../../components/admin/adminArticles';
import { auth } from '../../firebase';
import { useAuth } from '../../contexts/AuthContext';

export default function Admin() {
    const [activeTab, setActiveTab] = useState('blog');
    const [idToken, setIdToken] = useState('');
    const { user, loading, handleLogout } = useAuth();

    useEffect(() => {
        let cancelled = false;

        const refreshAdminToken = async () => {
            if (!user) {
                setIdToken('');
                return;
            }

            try {
                const firebaseUser = auth.currentUser;
                if (!firebaseUser) {
                    if (!cancelled) {
                        setIdToken('');
                    }
                    return;
                }

                const token = await firebaseUser.getIdToken(true);
                if (!cancelled) {
                    setIdToken(token);
                }
            } catch (error) {
                console.error('Error refreshing admin token:', error);
                if (!cancelled) {
                    setIdToken('');
                }
            }
        };

        refreshAdminToken();

        return () => {
            cancelled = true;
        };
    }, [user]);

    if (loading) {
        return (
            <div className="admin-container">
                <h1>Chargement...</h1>
            </div>
        );
    }

    if (!user) {
        return (
            <div className="admin-container">
                <h1>Chargement...</h1>
            </div>
        );
    }

    return (
        <div className="admin-container">
            <div className="admin-header">
                <h1>Administration</h1>
                <div className="admin-user-info">
                    <p>Connecté en tant que <strong>{user.email}</strong></p>
                    <button className="admin-logout-btn" onClick={handleLogout}>Déconnexion</button>
                </div>
            </div>
            
            <div className="admin-tab-buttons">
                <button 
                    className={`admin-tab-button ${activeTab === 'blog' ? 'active' : ''}`}
                    onClick={() => setActiveTab('blog')}
                >
                    Blog
                </button>
                <button 
                    className={`admin-tab-button ${activeTab === 'lookbook' ? 'active' : ''}`}
                    onClick={() => setActiveTab('lookbook')}
                >
                    Lookbooks
                </button>
                <button 
                    className={`admin-tab-button ${activeTab === 'users' ? 'active' : ''}`}
                    onClick={() => setActiveTab('users')}
                >
                    Utilisateurs
                </button>
                <button 
                    className={`admin-tab-button ${activeTab === 'articles' ? 'active' : ''}`}
                    onClick={() => setActiveTab('articles')}
                >
                    Articles
                </button>
            </div>
            
            <div className='admin-tab-content'>
                {activeTab === 'blog' && <AdminBlog idToken={idToken} />}
                {activeTab === 'lookbook' && <AdminLookbook idToken={idToken} />}
                {activeTab === 'users' && <AdminUsers idToken={idToken} />}
                {activeTab === 'articles' && <AdminArticles idToken={idToken} />}
            </div>
        </div>
    );
}